import { QueryKey, QueryKeyParam, createQueryKey } from '../../../query';

const discountsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'discounts'] as const,
    id: (itemId: QueryKeyParam) =>
      createQueryKey({
        all: [...keys, 'discounts', itemId] as const,
        detail: [...keys, 'discounts', itemId, 'detail'] as const,
      }),
  });

export { discountsKeys };
